import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** A gauge dial with its needle, marking a pressure value or unit. */
export var PressureGaugeIcon = function (_a) {
    var size = _a.size, className = _a.className;
    return (_jsxs("svg", { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("circle", { cx: "12", cy: "12", r: "10" }), _jsx("line", { x1: "8", y1: "16", x2: "16", y2: "8" }), _jsx("polyline", { points: "10.5 8 16 8 16 13.5" })] }));
};
